import { useSiteStatus } from "@iscr/xAppLib/Hooks";
function parseValue(value) {
    if (typeof value === "boolean" || value === "soft") {
        return value;
    }
    if (typeof value === "string" && ["false", "true"].includes(value)) {
        return value === "true";
    }
    if (typeof value === "undefined" || value === null) {
        return true;
    }
    // Misconfigured. Default to off.
    return false;
}
export function useMimsFeatureState() {
    return parseValue(useSiteStatus("mims_feature_status")); // Purely to ensure we re-render when the site status changes
}
/** The same, for class components that can't use the hook */
export function mimsFeatureState() {
    var _a;
    return parseValue((_a = app.site_status) === null || _a === void 0 ? void 0 : _a.mims_feature_status);
}
